var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_1049)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8087 73.458L0.0660587 32.464C-0.145691 31.8671 0.168652 31.2058 0.765621 30.9877C20.1486 24.0164 41.9899 17.5326 60.6605 9.56617C61.4948 9.03985 62.1495 9.55982 62.5089 10.5547L85.6723 70.2612L91.9623 87.754C92.174 88.351 91.866 89.0186 91.2691 89.2305L46.9448 105.17L29.6669 111.384C29.0699 111.602 28.4088 111.288 28.1907 110.691L14.8087 73.458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0997 59.8554L19.7381 16.9227C19.6289 16.2936 20.0527 15.6966 20.6752 15.5874L71.3727 6.89562L82.9833 4.98265C83.6188 4.70658 84.6522 5.02749 84.8958 6.4463L97.437 69.0738L100.576 87.3947C100.685 88.0175 100.261 88.6208 99.6385 88.73L53.2154 96.6901L35.116 99.797C34.4934 99.8998 33.8901 99.4761 33.781 98.8533L27.0997 59.8554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3022 47.1964V88.473C41.3022 89.1343 41.8414 89.6798 42.5025 89.6798H61.6608H90.0231H94.0986H110.799C111.46 89.6798 111.999 89.1343 111.999 88.473V69.0802V15.5105V14.952H99.8045C98.63 14.952 96.191 15.1189 96.191 12.455L96.1652 0.546875H42.5023C41.8412 0.546875 41.302 1.08609 41.302 1.74738V12.0505V16.4093V47.1964H41.3022Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9573 24.0417C14.0899 26.3528 7.28656 28.6445 0.765621 30.9875C0.168652 31.2058 -0.145691 31.8669 0.0660587 32.4638L14.8087 73.458L28.1907 110.69C28.4091 111.287 29.0701 111.602 29.6669 111.384L46.9448 105.17L86.3144 91.0149L20.9573 24.0417Z",
    fill: "#B5C4CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3033 12.0505L20.6752 15.5875C20.0527 15.6967 19.6289 16.2936 19.7381 16.9228L20.9576 24.0418L27.0999 59.8555L33.7812 98.8532C33.8903 99.4759 34.4937 99.8994 35.1162 99.7968L53.2156 96.6899L86.3144 91.0151L94.0997 89.6799H90.0242L41.3033 12.0505Z",
    fill: "#D7E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.999 69.0802V15.5105V14.952V14.7658C111.999 14.4191 111.851 14.3614 111.319 13.8414L98.1549 1.28516C97.5324 0.694531 97.4298 0.546875 97.0638 0.546875H96.1652H42.5023C41.8412 0.546875 41.302 1.08609 41.302 1.74738V88.473C41.302 89.1343 41.8412 89.6798 42.5023 89.6798H110.799C111.46 89.6798 111.999 89.1343 111.999 88.473V69.0802Z",
    fill: "#EDF3F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3026 12.0505L36.4697 12.8787V92.9091C36.4697 93.5767 37.0089 94.1159 37.67 94.1159H56.8284H68.2272L86.3137 91.0154L94.099 89.6801H90.0234H85.0108H61.6612H42.5029C41.8418 89.6801 41.3026 89.1345 41.3026 88.4733C41.3026 63.0009 41.3026 37.5224 41.3026 12.0505Z",
    fill: "#B5C4CF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1006 59.8555L20.9583 24.0417C19.296 24.6002 17.6401 25.1587 15.9905 25.7172L16.7544 30.1659L22.8966 65.9796L29.5845 104.977C29.6871 105.6 30.2904 106.024 30.9129 105.921L49.0123 102.814L57.6 101.344L83.4654 92.036L83.1574 91.5546L68.2286 94.1159L53.2165 96.6902L35.1171 99.7971C34.4945 99.8999 33.8912 99.4762 33.7821 98.8534L27.1006 59.8555Z",
    fill: "#9AAFB7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.999 69.0802V15.5105V14.952C111.999 14.3036 111.788 14.2973 111.319 13.8414L98.1553 1.28516C97.5327 0.694531 97.4301 0.546875 97.0641 0.546875H96.1655H82.8091C99.1307 22.3985 100.061 61.7877 87.9501 86.3739C87.3917 87.5166 86.8076 88.6143 86.198 89.6798H90.0232H94.0988H110.799C111.46 89.6798 111.999 89.1343 111.999 88.473V69.0802Z",
    fill: "#D7E7EC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1901 12.4547C96.1901 15.1187 98.629 14.9518 99.8037 14.9518H111.998V14.7656C111.998 14.4189 111.851 14.3611 111.318 13.8412L98.1543 1.28491C97.5317 0.694287 97.4291 0.546631 97.0632 0.546631H96.1646L96.1901 12.4547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.318 13.8414L98.1543 1.28516C97.5317 0.694531 97.4291 0.546875 97.0632 0.546875H96.1646L96.1901 12.4548C96.1901 15.1187 98.629 14.9518 99.8037 14.9518H111.998V14.7656C111.998 14.4191 111.851 14.3614 111.318 13.8414Z",
    fill: "#B5C4CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.153 26.7982H52.83C51.8965 26.7982 51.1399 26.0413 51.1399 25.1075C51.1399 24.1736 51.8965 23.4167 52.83 23.4167H101.153C102.086 23.4167 102.843 24.1736 102.843 25.1075C102.843 26.0413 102.086 26.7982 101.153 26.7982Z",
    fill: "#9AAFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.153 38.8087H52.83C51.8965 38.8087 51.1399 38.0518 51.1399 37.118C51.1399 36.1841 51.8965 35.4272 52.83 35.4272H101.153C102.086 35.4272 102.843 36.1841 102.843 37.118C102.843 38.0518 102.086 38.8087 101.153 38.8087Z",
    fill: "#9AAFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.153 50.8194H52.83C51.8965 50.8194 51.1399 50.0626 51.1399 49.1287C51.1399 48.1949 51.8965 47.438 52.83 47.438H101.153C102.086 47.438 102.843 48.1949 102.843 49.1287C102.843 50.0626 102.086 50.8194 101.153 50.8194Z",
    fill: "#9AAFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.153 62.8299H52.83C51.8965 62.8299 51.1399 62.073 51.1399 61.1392C51.1399 60.2054 51.8965 59.4485 52.83 59.4485H101.153C102.086 59.4485 102.843 60.2054 102.843 61.1392C102.843 62.073 102.086 62.8299 101.153 62.8299Z",
    fill: "#9AAFB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.153 74.8407H52.83C51.8965 74.8407 51.1399 74.0838 51.1399 73.1499C51.1399 72.2161 51.8965 71.4592 52.83 71.4592H101.153C102.086 71.4592 102.843 72.2161 102.843 73.1499C102.843 74.0838 102.086 74.8407 101.153 74.8407Z",
    fill: "#9AAFB7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_1049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageInfo);
export default __webpack_public_path__ + "static/media/page-info.eb48651894f83adc81f24e72c7a3bbe4.svg";
export { ForwardRef as ReactComponent };